/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ZoneOccupancySessionsRequestBody
 */
export interface ZoneOccupancySessionsRequestBody {
    /**
     * 
     * @type {string}
     * @memberof ZoneOccupancySessionsRequestBody
     */
    startingFrom: string;
    /**
     * 
     * @type {string}
     * @memberof ZoneOccupancySessionsRequestBody
     */
    endingAt: string;
    /**
     * 
     * @type {number}
     * @memberof ZoneOccupancySessionsRequestBody
     */
    localityId: number;
}

export function ZoneOccupancySessionsRequestBodyFromJSON(json: any): ZoneOccupancySessionsRequestBody {
    return ZoneOccupancySessionsRequestBodyFromJSONTyped(json, false);
}

export function ZoneOccupancySessionsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZoneOccupancySessionsRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startingFrom': json['starting_from'],
        'endingAt': json['ending_at'],
        'localityId': json['locality_id'],
    };
}

export function ZoneOccupancySessionsRequestBodyToJSON(value?: ZoneOccupancySessionsRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'starting_from': value.startingFrom,
        'ending_at': value.endingAt,
        'locality_id': value.localityId,
    };
}

